export const A_LICENSE_TYPE = [
  {
    number: 1,
    license_id: "A1",
  },
  {
    number: 2,
    license_id: "A2",
  },
  {
    number: 3,
    license_id: "A3",
  },
];

export const B_LICENSE_TYPE = [
  {
    number: 1,
    license_id: "B1",
  },
  {
    number: 2,
    license_id: "B2",
  },
  {
    number: 3,
    license_id: "B3",
  },
  {
    number: 4,
    license_id: "B4",
  },
];

export const C_LICENSE_TYPE = [
  {
    number: 1,
    license_id: "C1",
  },
  {
    number: 2,
    license_id: "C2",
  },
];

export const D_LICENSE_TYPE = [
  {
    number: 1,
    license_id: "D1",
  },
  {
    number: 2,
    license_id: "D2",
  },
  {
    number: 3,
    license_id: "D3",
  },
];

export const E_LICENSE_TYPE = [
  {
    number: 1,
    license_id: "E1",
  },
  {
    number: 2,
    license_id: "E2",
  },
];

export const ALL_LICENSE_TYPES_BY_GROUPS = [
  {
    label: "Tipo A",
    types: [
      {
        number: 1,
        license_id: "A1",
      },
      {
        number: 2,
        license_id: "A2",
      },
      {
        number: 3,
        license_id: "A3",
      },
    ],
  },
  {
    label: "Tipo B",
    types: [
      {
        number: 4,
        license_id: "B1",
      },
      {
        number: 5,
        license_id: "B2",
      },
      {
        number: 6,
        license_id: "B3",
      },
      {
        number: 7,
        license_id: "B4",
      },
    ],
  },
  {
    label: "Tipo C",
    types: [
      {
        number: 8,
        license_id: "C1",
      },
      {
        number: 9,
        license_id: "C2",
      },
    ],
  },
  {
    label: "Tipo D",
    types: [
      {
        number: 10,
        license_id: "D1",
      },
      {
        number: 11,
        license_id: "D2",
      },
      {
        number: 12,
        license_id: "D3",
      },
    ],
  },
  {
    label: "Tipo E",
    types: [
      {
        number: 13,
        license_id: "E1",
      },
      {
        number: 14,
        license_id: "E2",
      },
    ],
  },
];
